import { atom } from "recoil";

export const addCourseAtom = atom({
  key: "addCourseAtom",
  default: false,
});
